// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"7b654d58","194":"3ed7af36","215":"c43e9c04","291":"ea7ecbf5","355":"6366ddda","430":"0e990679","530":"a12f6426","679":"13d699e8","699":"0eb47024","715":"e9ada904","777":"7128e0b3","958":"7ba08615","973":"9e8745b4"}[chunkId] + ".chunk.js";
};